/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

/**
 * Formats a string to be compatible with <Markdown>...</Markdown>
 * by splitting sentences into bulleted lines.
 * @param str
 */
const bulletFormat = (str: string) =>
  str
    .split('. ')
    .filter(str => str.length > 0)
    .map(str => {
      const period = str.endsWith('.') ? '' : '.'
      return str.startsWith('\n') ? `\n${str}${period}` : `\n- ${str}${period}`
    })
    .join('')

export const MarkdownHelpers = {
  format: bulletFormat,
}
